// Backend actors are opaque subjects: an identity-provider id for ops, an eMAID
// for the customer, and the literal "SYSTEM" for something the backend did on
// its own. None of those belong on screen as-is, so every view that shows
// "who did this" goes through here.

export const actorLabel = (actor?: string | null): string => {
  if (!actor) return "";
  if (actor === "SYSTEM") return "Automatic";
  // Auth0 subjects are "<connection>|<id>" — auth0|…, google-oauth2|…,
  // windowslive|… and so on. Matching only "auth0|" let a google-oauth2 subject
  // through onto the screen, so the pipe is what identifies them. An eMAID
  // (DE-COC-…) has no pipe and is deliberately left readable.
  if (actor.includes("|")) return "Ops";
  return actor;
};
